import { createTheme } from '@mui/material'
import { borderGrayColor, dangerColor, grayColor, infoColor, infoColorDisabled, infoColorHover } from 'assets/jss/main'

const waybillTheme = createTheme({
    palette: {
        primary: {main: '#007DFF'},
    },
})

const waybillStyle = theme => ({
    paper: {
        display: 'inline-flex',
        padding: 24,
        gap: '32px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        boxShadow: '0px 4px 22px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '8px',
        '& .MuiDialogContent-root': {
            padding: 0,
        },
        '& .MuiDialogContent-root h2': {
            padding: 0,
            margin: 0,
            marginBottom: '32px',
            color: '#333',
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
        '& .MuiDialogActions-root > :not(:first-of-type) ': {
            marginLeft: '12px',
        },
        '& .MuiDialogActions-root': {
            padding: 0,
            justifyContent: 'flex-end',
        },
    },
    errorMessage: {
        color: dangerColor,
        marginBottom: '10px',
    },
    selector: {
        width: '496px',
        display: 'flex',
        gap: '24px',
        alignItems: 'center',
        padding: '16px 24px',
        marginBottom: '16px',
        borderRadius: '8px',
        border: `1px solid ${borderGrayColor}`,
        cursor: 'pointer',
        '&:last-child': {
            marginBottom: 0,
        },
        '& h3': {
            padding: 0,
            margin: 0,
            marginBottom: '12px',
            color: '#333',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
        '& p': {
            padding: 0,
            margin: 0,
            color: '#333',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.15px',
        },
        '& .MuiInput-input': {
            color: grayColor,
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '16px',
            borderColor: grayColor,
        },
    },
    selected: {
        borderColor: '#000',
    },
    selectorShipping: {
        '& .MuiTextField-root': {
            marginTop: '28px',
        },
    },
    selectorSelfShipping: {
        '& .MuiTextField-root': {
            marginTop: '8px',
        },
    },
    actionButton: {
        padding: '12px 16px',
        color: '#333',
        fontSize: '14px',
        lineHeight: '14px',
        fontWeight: 400,
        textTransform: 'none',
        borderRadius: 8,
        border: `1px solid ${borderGrayColor}`,
        '&:hover': {
            backgroundColor: '#F1F1F1',
        },
    },
    validatedButton: {
        color: '#FFF',
        backgroundColor: infoColor,
        '&:hover': {
            backgroundColor: infoColorHover,
        },
        '&.Mui-disabled': {
            color: '#FFF',
            backgroundColor: infoColorDisabled,
        },
    },
})

export { waybillTheme, waybillStyle };
